define('controllers/hotelattributes',['require'],function(require) {
    return function() {
        var msg = $(".msg");

        $("#btnSave").on("click", function () {
            var $this = $(this);
            $this.prop('disabled', true);
            msg.hide();

            $.post("HotelAttributesAJAX.aspx", { hotelId: requestQueryString("hid"), attributes: getSelectedAttributes().join(",") }, function (response) {
                Utilities.handleAJAXResponse(response, function (respObj) {
                    Utilities.setInfo("Saved Successfully", msg);
                }, function (error) {
                    Utilities.setError(error, msg);
                });
            }).error(function () {
                Utilities.setError("There was an error saving.", msg);
            }).complete(function () {
                $this.prop('disabled', false);
            });
        });

        function getSelectedAttributes() {
            var attributes = [];
            $("#manageAttributes input[type='checkbox']:checked").each(function () {
                attributes.push($(this).val());
            });
            return attributes;
        }
    };
});

